
<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="personnelBonusComputed"
              :items-per-page="50"
              item-key="id"
              sort-by="name"
              show-expand
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Bonus Rates</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <span>
                    <v-combobox
                        :items="periodList"
                        label="Select Start Period"
                        item-text="text"
                        single-line
                        return-object
                        v-on:change="startPeriodChanged"
                    ></v-combobox>
                  </span>
                  <v-spacer></v-spacer>
                  <span>
                    <v-combobox
                        :items="periodList"
                        label="Select End Period"
                        item-text="text"
                        single-line
                        return-object
                        v-on:change="endPeriodChanged"
                    ></v-combobox>
                  </span>
                  <v-spacer></v-spacer>
                  <span>
                    <v-combobox
                        :items="bonusTypeList"
                        label="Select Bonus Type"
                        item-text="name"
                        single-line
                        return-object
                        v-on:change="bonusTypeChanged"
                    ></v-combobox>
                  </span>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap>   
                  <v-flex xs1></v-flex>
                  <v-flex xs11>
                    Totals
                  </v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs2 v-if="bonusSummaryFormatted.incomeAmountTotal">
                    Income: {{bonusSummaryFormatted.incomeAmountTotalFP }}
                  </v-flex>                  
                  <v-flex xs2 v-if="bonusSummaryFormatted.incomeAmountToBonus">
                    Bonus: {{bonusSummaryFormatted.incomeAmountToBonusFP}}
                  </v-flex>
                  <v-flex xs2 v-if="bonusSummaryFormatted.expenseAmountTotal">
                    Expense: {{bonusSummaryFormatted.expenseAmountTotalFP}}
                  </v-flex>
                  <v-flex xs1></v-flex>    
                  <v-flex xs2 v-if="bonusSummaryFormatted.totalSeniorityMonths"> 
                    Seniority: {{bonusSummaryFormatted.totalSeniorityMonths}}
                  </v-flex>
                  <v-flex xs2 v-if="bonusSummaryFormatted.earningsAmount"> 
                    Profit: {{bonusSummaryFormatted.earningsAmountFP}}
                  </v-flex>
                  <v-flex xs1></v-flex> 
                  <v-flex xs2 v-if="bonusSummaryFormatted.personelSalaryTotal">
                    Salary: {{bonusSummaryFormatted.personelSalaryTotalFP}}
                  </v-flex>       
                  <v-flex xs1></v-flex>           
                </v-layout>
                <v-dialog v-model="dialog" max-width="800px">                    
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }} - {{editedItem.personnelFullname}} </span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout row>                                
                          
                          <v-flex xs12 sm7 md7>
                            <v-text-field 
                              :key="preconditionItem.preconditionId"
                              v-for="preconditionItem in editedItem.bonusTypePreconditions"
                              v-model="preconditionItem.precondition" 
                              disabled label=""></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm5 md5>
                            <v-radio-group 
                              row
                              v-model="editedItem.bonusTypePreconditions[preconditionItem.orderNo].conditionValue"
                              :key="preconditionItem.preconditionId"
                              v-for="preconditionItem in editedItem.bonusTypePreconditions">
                                  <v-radio
                                    :key="1"
                                  :label="`YES`"
                                  :value="1"
                                  ></v-radio>
                                  <v-radio
                                    :key="0"
                                  :label="`NO`"
                                  :value="0"
                                  ></v-radio>
                            </v-radio-group>
                          </v-flex>                                                                                                                                                                                                                             
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                      <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 


              <template v-slot:expanded-item="{ headers, item: masterItem }">
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs3>
                      Income List                  
                    </v-flex>
                    <v-flex xs9>                       
                    </v-flex>
                    <v-flex xs12>




                      <v-data-table
                      :headers="bonusIncomesHeaders"
                      :items="masterItem.bonusTypeIncomeList"
                      :items-per-page="25"
                      item-key="id"
                      sort-by="incomeDate"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>       
                      <template v-slot:item.getIncomeResource="{ item }">                 
                        {{item.sale? 'Sale '+item.sale.id : ''}}         
                      </template>        
                      <template v-slot:item.getIncomeResourceDate="{ item }">                 
                        {{item.sale? item.sale.saleDate : ''}}         
                      </template>  
                    </v-data-table>



                    </v-flex>
                  </v-layout>
                </td>                
              </template>


              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.personnelBonusActions="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>               
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import formatPrice from '../helpers/formatter';
const API_URL = 'personnelBonusRates';
const BONUS_TYPES_API_URL = 'definitions/bonusTypes';
const PERIODS_API_URL = 'definitions/periods';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Progress
    },
    data () {
    return {
      dialog: false,
      search: '',
      showProgress : false,
      periodList: [],
      bonusTypeList: [],
      currentUserId: '',
      bonusSummary: '',
      personnelBonus: [],
      selectedStartPeriod: -1,
      selectedEndPeriod: -1,
      selectedBonusTypeId: -1,
      editedIndex: -1,
      editedItem: {
        model: '',
          reviewerId: '',
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Personnel Fullname',align: 'left',sortable: true,value: 'personnelFullname' },     
        { text: 'Bonus Amount',  value: 'calculatedBonus' ,align: 'right'  },                      
        { text: 'Preconditions',  value: 'preconditions' ,align: 'center' },
        { text: 'Seniority',  value: 'seniorityMonths'  },                   
        { text: 'Salary',  value: 'personnelSalary' ,align: 'right' }, 
        { text: 'Rating Avg.',  value: 'ratingAvarage' ,align: 'center' },        
        { text: 'Actions', value: 'personnelBonusActions', sortable: false },
      ]
    },
    bonusIncomesHeaders () {
      return [
        { text: 'Income Id',  value: 'id'  }, 
        { text: 'Income Date',  value: 'incomeDate'  },          
        { text: 'Resource', value: 'getIncomeResource' },        
        { text: 'Resource Date', value: 'getIncomeResourceDate' },           
        { text: 'Bonus Amount',  value: 'bonusAmount'  }, 
        { text: 'Bonus Currency',  value: 'bonusCurrency.code'  }, 
        { text: 'Income Amount',  value: 'amount'  }, 
        { text: 'Income Currency',  value: 'currency.code'  }, 
        { text: 'Explanation',  value: 'explanation'  },           
      ]
    },
    personnelBonusComputed(){
      return this.personnelBonus.map((item) => {   
        let allPreconditions = 0;
        let metPreconditions = 0;
        if(item.bonusTypePreconditions){
          allPreconditions = item.bonusTypePreconditions.length;
          metPreconditions = item.bonusTypePreconditions.filter(c => c.conditionValue == 1).length;
        }
        item.preconditions = metPreconditions+'/'+allPreconditions;  
        
        if(metPreconditions<allPreconditions 
           && this.selectedStartPeriod && this.selectedEndPeriod && this.selectedStartPeriod == this.selectedEndPeriod){
          item.calculatedBonus = 0.00;
        }else{
          item.calculatedBonus = formatPrice(item.calculatedBonus);
        }

        if(item.bonusTypeIncomeList){
          item.bonusTypeIncomeList.map((incomeItem) => { 
            incomeItem.amount = formatPrice(incomeItem.amount);
            incomeItem.bonusAmount = formatPrice(incomeItem.bonusAmount);
          })
        }else{
          item.bonusTypeIncomeList = [];
        }
        return item;    
      })
    },
    bonusSummaryFormatted(){
      return {
          incomeAmountTotal: this.bonusSummary.incomeAmountTotal,
          incomeAmountTotalFP: formatPrice(this.bonusSummary.incomeAmountTotal),

          incomeAmountToBonus: this.bonusSummary.incomeAmountToBonus,
          incomeAmountToBonusFP: formatPrice(this.bonusSummary.incomeAmountToBonus),

          expenseAmountTotal: this.bonusSummary.expenseAmountTotal,
          expenseAmountTotalFP: formatPrice(this.bonusSummary.expenseAmountTotal),

          earningsAmount: this.bonusSummary.earningsAmount,
          earningsAmountFP: formatPrice(this.bonusSummary.earningsAmount),

          totalSeniorityMonths: this.bonusSummary.totalSeniorityMonths,

          personelSalaryTotal: this.bonusSummary.personelSalaryTotal,          
          personelSalaryTotalFP: formatPrice(this.bonusSummary.personelSalaryTotal) 
        };
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Personnel Rating' : 'Edit Personnel Preconditions'
    },
  },
  created() {    
    this.getPerformancePeriodList();
    this.getBonusTypes();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  beforeMount() {
      if (localStorage.user_id) {
        this.currentUserId = localStorage.getItem('user_id');
      }
    },
  methods: {
    startPeriodChanged(item){
      this.selectedStartPeriod = item.id;
      if( this.selectedEndPeriod && this.selectedEndPeriod > 0 && this.selectedBonusTypeId && this.selectedBonusTypeId>0 && this.selectedStartPeriod>0){
        this.showProgress = true;
        this.getPersonnelBonusRates(this.selectedStartPeriod,this.selectedEndPeriod, this.selectedBonusTypeId);
      } 
    },
    endPeriodChanged(item){
      this.selectedEndPeriod = item.id;
      if( this.selectedStartPeriod && this.selectedStartPeriod > 0 && this.selectedBonusTypeId && this.selectedBonusTypeId>0 && this.selectedEndPeriod>0){
        this.showProgress = true;
        this.getPersonnelBonusRates(this.selectedStartPeriod,this.selectedEndPeriod, this.selectedBonusTypeId);
      } 
    },
    bonusTypeChanged(item){
      this.selectedBonusTypeId = item.id;
      if( this.selectedStartPeriod && this.selectedStartPeriod > 0 && this.selectedEndPeriod && this.selectedEndPeriod>0 && this.selectedBonusTypeId>0){
        this.showProgress = true;
        this.getPersonnelBonusRates(this.selectedStartPeriod,this.selectedEndPeriod, this.selectedBonusTypeId);
      }     
    },
    editItem (item) {         
      if(this.selectedStartPeriod && this.selectedEndPeriod && this.selectedStartPeriod != this.selectedEndPeriod){
        alert('Please select only one period to edit info');
        return;
      }
      this.editedIndex = this.personnelBonus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.personnelBonus.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.personnelBonus.splice(index, 1);
        this.deleteBonusRate(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateBonusRate(this.editedItem);
      }      
    },   
    updateBonusRate(item){
      this.$axios.put(this.$apiurl+API_URL, {        
        periodId: this.selectedStartPeriod,        
        personnelId: item.personnelId,
        bonusTypeId:this.selectedBonusTypeId,
        preconditions: item.bonusTypePreconditions
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.personnelBonus[this.editedIndex], this.editedItem);
          if( this.selectedStartPeriod && this.selectedStartPeriod > 0 && this.selectedEndPeriod && this.selectedEndPeriod>0 
              && this.selectedBonusTypeId   && this.selectedBonusTypeId>0){
            this.showProgress = true;
            this.getPersonnelBonusRates(this.selectedStartPeriod,this.selectedEndPeriod, this.selectedBonusTypeId);
          }   
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteBonusRate(item){
      this.$axios.delete(this.$apiurl+API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getPersonnelBonusRates(startPeriodId, endPeriodId, bonusTypeId){     
      this.bonusSummary = '',
      this.personnelBonus= [],
        this.$axios.get(this.$apiurl+API_URL+'/interval/'+startPeriodId+'/'+endPeriodId+'/'+bonusTypeId)
            .then(response => {
              this.bonusSummary = response.data;
              this.personnelBonus = response.data.personelBonusSummaryList;
              this.showProgress = false;
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },    
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl+PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getBonusTypes(){     
        this.$axios.get(this.$apiurl+BONUS_TYPES_API_URL)
            .then(response => {
                this.bonusTypeList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
